import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 54 66",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M24.6635 15H29.3364M26.9999 1V2M33.3639 3.63604L32.6568 4.34315M36 9.99995H35M19 9.99995H18M21.3431 4.34315L20.636 3.63604M23.4644 13.5356C21.5118 11.5829 21.5118 8.41711 23.4644 6.46449C25.417 4.51187 28.5829 4.51187 30.5355 6.46449C32.4881 8.41711 32.4881 11.5829 30.5355 13.5356L29.9884 14.0827C29.3555 14.7155 28.9999 15.5739 28.9999 16.469V17C28.9999 18.1046 28.1045 19 26.9999 19C25.8954 19 24.9999 18.1046 24.9999 17V16.469C24.9999 15.5739 24.6444 14.7155 24.0115 14.0827L23.4644 13.5356Z",
      stroke: "#FDBD00",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M39.5 64H52V59C52 54.8579 48.6421 51.5 44.5 51.5C42.111 51.5 39.9829 52.617 38.6094 54.3572M39.5 64H14.5M39.5 64V59C39.5 57.3594 39.1839 55.7926 38.6094 54.3572M14.5 64H2V59C2 54.8579 5.35786 51.5 9.5 51.5C11.889 51.5 14.0171 52.617 15.3906 54.3572M14.5 64V59C14.5 57.3594 14.8161 55.7926 15.3906 54.3572M15.3906 54.3572C17.2338 49.7526 21.737 46.5 27 46.5C32.263 46.5 36.7662 49.7526 38.6094 54.3572M34.5 31.5C34.5 35.6421 31.1421 39 27 39C22.8579 39 19.5 35.6421 19.5 31.5C19.5 27.3579 22.8579 24 27 24C31.1421 24 34.5 27.3579 34.5 31.5ZM49.5 39C49.5 41.7614 47.2614 44 44.5 44C41.7386 44 39.5 41.7614 39.5 39C39.5 36.2386 41.7386 34 44.5 34C47.2614 34 49.5 36.2386 49.5 39ZM14.5 39C14.5 41.7614 12.2614 44 9.5 44C6.73858 44 4.5 41.7614 4.5 39C4.5 36.2386 6.73858 34 9.5 34C12.2614 34 14.5 36.2386 14.5 39Z",
      stroke: "#FD8B00",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }